import { HStack, SkeletonCircle, SkeletonText } from "@chakra-ui/react";
import React, { forwardRef, ReactNode } from "react";

import {
  MotionFilter,
  MotionFilterProps,
} from "@/common/components/MotionComponents";
import { TagRemove } from "@/common/components/TagButtons";

type RuleSimpleSelectionProps = MotionFilterProps & {
  children: ReactNode;
  isLoading?: boolean;
  readOnly?: boolean;
  type?: "company" | "user";
  isSummary?: boolean;
  onRemove?: () => void;
};

export const RuleSimpleSelection = forwardRef<
  HTMLDivElement,
  RuleSimpleSelectionProps
>(
  (
    {
      children,
      isLoading,
      readOnly,
      type = "company",
      isSummary,
      onRemove,
      ...rest
    },
    ref,
  ) => {
    const skeletonAvatar =
      type === "company" ? (
        <SkeletonCircle rounded={4} size="5" />
      ) : (
        <SkeletonCircle size="5" />
      );
    return (
      <MotionFilter
        ref={ref}
        cursor="default"
        pos="relative"
        role="group"
        size="sm"
        tabIndex={0}
        variant="clickable"
        {...rest}
      >
        {isLoading ? (
          <HStack>
            {isSummary ? (
              <HStack spacing={-0.5}>
                {skeletonAvatar}
                {skeletonAvatar}
                {skeletonAvatar}
              </HStack>
            ) : (
              skeletonAvatar
            )}
            <SkeletonText noOfLines={1} w={16} />
          </HStack>
        ) : (
          children
        )}
        {!readOnly && onRemove && <TagRemove onRemove={onRemove} />}
      </MotionFilter>
    );
  },
);

RuleSimpleSelection.displayName = "RuleSimpleSelection";
